import { Email } from "@/Common/Api/Contacts/Dto/Email";

interface IEmailSectionProps {
    emails: Email[]
}

function EmailSection(props: IEmailSectionProps): JSX.Element {
    const emails = props.emails;

    return (
        <div>
            <div className="view-section-header">
                <h3 className="view-section-title">{cacheStore.GetString("EmailLabel")}</h3>
            </div>
            <div className="view-section-body">
                {emails.sortByPropertyDesc(c => c.IsPreferred).map((email: Email, idx: number) => (
                    <div id={"__i" + idx} key={"__k" + idx} style={{ "marginBottom": "10px" }}>
                        <div className="row">
                            <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("TypeLabel")}</label>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                <strong>{cacheStore.GetLocalizedValueByLookupId(email.ContactPointTypeLookupId)}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("AddressLabel")}</label>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                <strong>{email.Address}</strong>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default EmailSection;
